import React, { Component, ErrorInfo } from 'react';
import { ServiceUnavailable } from './ServiceUnavailable';

interface Props {
  children: React.ReactNode;
  moduleName: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * Per-module ErrorBoundary — isolates crashes to one module.
 * If Actions CAPA crashes, other modules (Contexte, Organisation, etc.) stay accessible.
 */
export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Log to console but don't crash the rest of the app
    // eslint-disable-next-line no-console
    console.error(`[${this.props.moduleName}] Error boundary caught:`, error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ServiceUnavailable
          service={this.props.moduleName}
          message={this.state.error?.message || 'Erreur inattendue dans ce module'}
          onRetry={this.handleRetry}
        />
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
